// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1b8O9","buttons":"styles_buttons__27-QC"};